import { render, staticRenderFns } from "./JCC.vue?vue&type=template&id=387d5e1c&scoped=true"
import script from "./JCC.vue?vue&type=script&lang=js"
export * from "./JCC.vue?vue&type=script&lang=js"
import style0 from "./JCC.vue?vue&type=style&index=0&id=387d5e1c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d5e1c",
  null
  
)

export default component.exports